// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	production: false,
	API_ENDPOINT: 'https://api-staging.miletrackgps.com/api',
	// API_ENDPOINT: 'https://api.miletrackgps.com/api'
	// API_ENDPOINT: 'http://miletrackapi.cabotprojects.com/api',
	// API_ENDPOINT: 'http://192.168.5.40:3006/api'
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/environments/environment.ts